import React, { useEffect, useState, useRef } from 'react';
import AudioPlayer from 'react-h5-audio-player';

import GuidePermainan from './gameComponents/GuidePermainan';
import WelcomeSection from './gameComponents/WelcomeSection';
import HeaderGame from '../../partials/HeaderGame';

import Soal1 from './gameComponents/Soal1';
import Soal2 from './gameComponents/Soal2';
import Soal3 from './gameComponents/Soal3';
import Soal4 from './gameComponents/Soal4';
import Soal5 from './gameComponents/Soal5';
import Soal6 from './gameComponents/Soal6';
import Soal7 from './gameComponents/Soal7';
import Soal8 from './gameComponents/Soal8';
import Footer from '../../partials/Footer';

import logoMusic from '../../assets/images/game/w2_buttons/Music.png';
import logoPause from '../../assets/images/game/w2_buttons/pause.png';
import Music from '../../assets/sounds/game/w2_music/music-game.mp3';


const Game = () => {

    const [music, setMusic] = useState(false);

    const guide = useRef(null);
    const q1 = useRef(null);
    const toGuide = () => guide.current.scrollIntoView();

    //music
    const player = useRef();
    const audioPlay = () => {
        player.current.audio.current.play();
        setMusic(true)
    };
    const audioPause = () => {
        player.current.audio.current.pause();
        setMusic(false)
    };

    return (
        <>
        <HeaderGame />
        {
            music === false
            ?   <button onClick={audioPlay} className="border-0 bg-transparent sound-game">
                    <img src={logoMusic} alt="Sound" />
                </button>
            :   <button onClick={audioPause} className="border-0 bg-transparent sound-game">
                    <img src={logoPause} alt="Sound" />
                </button>
        }
        
        <div id='modal-root'></div>
        <div className="bg-welcome position-relative">
            <WelcomeSection scrollEvents={toGuide} />
        </div>
        <div className="bg-guide" ref={guide}>
            <GuidePermainan scrollEvents={() => q1.current.scrollIntoView()} />
        </div>
        <div className="bg-game-1 py-5" ref={q1}>
            <Soal1 />
        </div>
        <div className="bg-game-2 py-5" id="q2">
            <Soal2 />
        </div>
        <div className="bg-game-3 py-5" id="q3">
            <Soal3 />
        </div>
        <div className="bg-game-2 py-5" id="q4">
            <Soal4 />
        </div>
        <div className="bg-game-3 py-5" id="q5">
            <Soal5 />
        </div>
        <div className="bg-game-2 py-5" id="q6">
            <Soal6 />
        </div>
        <div className="bg-game-4 py-5" id="q7">
            <Soal7 />
            <Soal8 />
        </div>
        <Footer/>
        <AudioPlayer
            preload='metadata'
            src={Music}
            onPlay={e => console.log("onPlay")}
            ref={player}
        />
        </>
    )
}

export default Game